import { createContext, ReactNode, useEffect, useState } from 'react'

import { GlobalClient } from '@tribeplatform/gql-client/client'

import type { TribeClientConfig } from './@types/index.js'

export type GlobalClientContextProps = {
  client: GlobalClient
  config: TribeClientConfig
}
export type GlobalClientProviderType = React.FC<{
  children: ReactNode
  config: TribeClientConfig
}>

export const GlobalClientContext = createContext<GlobalClientContextProps>({
  client: null,
  config: null,
})

export const GlobalClientProvider: GlobalClientProviderType = ({
  children,
  config,
}) => {
  const { accessToken, baseUrl } = config

  let graphqlUrl = baseUrl
  if (!graphqlUrl && typeof process !== 'undefined') {
    graphqlUrl = process?.env?.TRIBE_GQL_ENDPOINT
  }

  const [globalClient, setGlobalClient] = useState<GlobalClient>(
    new GlobalClient({
      accessToken,
      graphqlUrl,
      onError: config.onError,
      onEvent: config.onEvent,
      notifyOnTokenExpiration: true,
    }),
  )

  useEffect(() => {
    if (typeof accessToken !== 'undefined' && accessToken !== '') {
      setGlobalClient(
        new GlobalClient({
          accessToken,
          graphqlUrl,
          onError: config.onError,
          onEvent: config.onEvent,
          notifyOnTokenExpiration: true,
        }),
      )
    }
  }, [accessToken, config])

  return (
    <GlobalClientContext.Provider value={{ client: globalClient, config }}>
      {children}
    </GlobalClientContext.Provider>
  )
}
